// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import { clientEnv } from "@shared/env/browser.ts";
import type { Database } from "./types.ts";

export const SUPABASE_URL = clientEnv.SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = clientEnv.SUPABASE_ANON_KEY;

if (!SUPABASE_URL) {
	throw new Error("Missing SUPABASE_URL environment variable.");
}

if (!SUPABASE_PUBLISHABLE_KEY) {
	throw new Error("Missing SUPABASE_ANON_KEY environment variable.");
}

// Import the supabase client like this:
// import { supabase } from "@shared/integrations/supabase/client";

export const supabase = createClient<Database>(
	SUPABASE_URL,
	SUPABASE_PUBLISHABLE_KEY,
	{
		auth: {
			storage: localStorage,
			persistSession: true,
			autoRefreshToken: true,
		},
	},
);
